// Startziel nach dem Anmelden. Der Schwellenwert 992 px ist derselbe, ab dem das Theme die
// Sidebar ausblendet — darunter waere die Desktop-Ansicht ohne erreichbare Navigation.
// Beide Bereiche bleiben ueber die Kopfzeile wechselseitig erreichbar, niemand sitzt fest.
export const MOBILE_BREAKPOINT = 992;

export const isSmallScreen = () => typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;

// Eine Instanz kann sich fest als Mobil-Vorschau ausweisen (VUE_APP_START_AREA=mobile, siehe
// .env.mobile). Dann startet auch ein breites Fenster im /m-Bereich — sonst landet man beim
// Vorfuehren am Rechner in der Desktop-Ansicht.
export const forcesMobile = () => process.env.VUE_APP_START_AREA === "mobile";

export const startRoute = () => (forcesMobile() || isSmallScreen() ? "/m" : "/app/dashboard");

export default startRoute;
